export default "__VITE_ASSET__77373ade__"